// Картата „Продукти" на листа „Доставка": заглавие с броя, чиповете „общо
// количество по мерна единица" и решетката/картите с един keydown handler за
// стрелките (`onGridKey`). Фактура над стокови брои и техните редове („1 продукт
// от стокова") и ги слага в чиповете. Картата расте до края на екрана и скролва вътре —
// заглавният ред на решетката остава лепнат.
import type { ComponentProps } from "react";
import { useTranslation } from "react-i18next";
import { DeliveryWorksheetTable } from "./DeliveryWorksheetTable";
import { withNoteUnitTotals } from "./deliveryMeta";
import { formatQtyInput } from "./deliveryWorksheetShared";

type Props = {
  unitTotals: [string, { qty: number; dec: number }][];
  onGridKey: (event: React.KeyboardEvent) => void;
  table: ComponentProps<typeof DeliveryWorksheetTable>;
};

export const DeliveryProductsCard = ({ unitTotals, onGridKey, table }: Props) => {
  const { t } = useTranslation();
  const count = table.addedProducts.length;
  const noteLines = table.linkedNotes.reduce((sum, note) => sum + note.lines.length, 0);
  const countLabel = [
    count || !noteLines ? t("inventoryPage.homeDraftLines", { count }) : null,
    noteLines ? t("inventoryPage.notesRowsCount", { count: noteLines }) : null,
  ]
    .filter(Boolean)
    .join(" · ");
  const units = withNoteUnitTotals(unitTotals, table.linkedNotes, table.productById, table.decimalsOf);
  return (
    <div className="flex min-h-[360px] flex-1 flex-col overflow-hidden rounded-xl border border-shade-2 bg-panel">
      <div className="flex flex-wrap items-center gap-2.5 px-[18px] py-[13px]">
        <span className="text-[15px] font-semibold text-ink">{t("inventoryPage.productsTitle")}</span>
        <span className="text-[12.5px] text-muted">{countLabel}</span>
        <div className="flex-1" />
        {units.map(([unit, { qty, dec }]) => (
          <span key={unit} className="rounded-full bg-fill-2 px-2.5 py-[3px] text-[12.5px] text-ink-2">
            <span className="font-sheet font-semibold">{formatQtyInput(qty, dec)}</span> {unit}
          </span>
        ))}
      </div>
      <div
        className={`min-h-0 flex-1 overflow-auto border-t border-shade-2 text-[13px] ${
          count || noteLines ? "bg-surface" : "bg-panel"
        }`}
        onKeyDown={onGridKey}
      >
        <DeliveryWorksheetTable {...table} />
      </div>
    </div>
  );
};

export default DeliveryProductsCard;
